/* eslint-disable @next/next/no-img-element */
import { URL_IMG } from '@/constants/ui'
import { Box, Stack, Typography } from '@mui/material'
import parser from 'html-react-parser'
type Props = {
  title: string
  align?: 'center' | 'left'
}

export const TitleLoginForm = ({ title, align = 'left' }: Props) => {
  return (
    <Stack spacing={1} alignItems={align === 'center' ? 'center' : 'flex-start'}>
      <Stack
        direction={'row'}
        alignItems={'center'}
        spacing={'4px'}
        mb={1}
        sx={{
          fontSize: {
            xs: '1.5em',
            md: '2em',
          },
        }}
      >
        <Box sx={{ display: 'inline' }}>
          <img
            src={URL_IMG + 'favicon-black.svg'}
            alt="Favicon"
            style={{
              width: '1em',
              height: '1em',
              objectFit: 'contain',
            }}
          />
        </Box>
        <Typography sx={{ fontSize: '.5em', fontWeight: 600 }}> - </Typography>
        <Typography
          variant="body2"
          fontWeight="600"
          mb={2}
          textTransform="uppercase"
          sx={{
            fontSize: {
              md: '.675em',
            },
          }}
        >
          Member
        </Typography>
      </Stack>
      <Typography
        variant="h2"
        sx={{
          fontSize: {
            xs: '1.5em',
            md: '2em',
          },
          fontWeight: 600,
          lineHeight: 1.5,
          textAlign: align,
        }}
      >
        {parser(title)}
      </Typography>
    </Stack>
  )
}
